/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStepInto = createReactComponent("step-into", "IconStepInto", [
  ["path", { d: "M12 3l0 12", key: "svg-0" }],
  ["path", { d: "M16 11l-4 4", key: "svg-1" }],
  ["path", { d: "M8 11l4 4", key: "svg-2" }],
  ["path", { d: "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-3" }]
]);

export { IconStepInto as default };
//# sourceMappingURL=IconStepInto.js.map
